import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";

import { PermisoGuard, PermisoDirective } from './utilidades.index';

import { CallesService, LocalidadesService, PadronService, TiposDeDocumentosService, UtilidadesService } from './utilidades.servicios.index';

import { AyudaComponent, BuscadorCallesComponent, BuscadorLocalidadesComponent, FileUploadComponent, FileUploadConfiguracionComponent, InicioComponent, LabelInformacionComponent, MenuComponent, SubmenuComponent, NavbarComponent, PopUpComponent, VisorDeArchivosComponent } from "./utilidades.componentes.index";

import { ConversorBytesPipe, CuitPipe, DniPipe, FiltroPipe, HtmlSeguroPipe, PatentePipe, SumarCampoPipe, UrlSeguraPipe } from "./utilidades.pipes.index";

import { MaterialAngularModule } from './MaterialAngular/material-angular.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { MenuButtonComponent } from './Componentes/menu-button/menu-button.component';
import { StickyFooterComponent } from './Componentes/sticky-footer/sticky-footer.component';

@NgModule({
	declarations: [
		//Componentes
		AyudaComponent, BuscadorCallesComponent, BuscadorLocalidadesComponent, FileUploadComponent, FileUploadConfiguracionComponent, InicioComponent, LabelInformacionComponent, MenuComponent, SubmenuComponent, NavbarComponent, PopUpComponent, VisorDeArchivosComponent,

		//Directivas
		PermisoDirective,

		//Pipes
		ConversorBytesPipe, CuitPipe, DniPipe, FiltroPipe, HtmlSeguroPipe, PatentePipe, SumarCampoPipe, UrlSeguraPipe, MenuButtonComponent, StickyFooterComponent
	],
	imports: [
		CommonModule,
		HttpClientModule,
		MaterialAngularModule,
		RouterModule,
		FormsModule
	],
	providers: [
		CallesService, LocalidadesService, PadronService, TiposDeDocumentosService, UtilidadesService

		, PermisoGuard
	],
	entryComponents: [
		PopUpComponent
	],
	exports: [
		//Componentes
		AyudaComponent, BuscadorCallesComponent, BuscadorLocalidadesComponent, FileUploadComponent, FileUploadConfiguracionComponent, InicioComponent, LabelInformacionComponent, MenuComponent, SubmenuComponent, NavbarComponent, PopUpComponent, VisorDeArchivosComponent, StickyFooterComponent,

		//Directivas
		PermisoDirective,

		//Pipes
		ConversorBytesPipe, CuitPipe, DniPipe, FiltroPipe, HtmlSeguroPipe, PatentePipe, SumarCampoPipe, UrlSeguraPipe,

		MaterialAngularModule
	]
})
export class UtilidadesModule {}